import React, { useRef } from "react";
import { Segment, Container, Grid, Placeholder, Ref, Rail, Header, Sticky, Image } from "semantic-ui-react";
import SearchResidenceCard from "../../components/SearchResidenceCard/SearchResidenceCard";
import InfiniteScroll from 'react-infinite-scroller';
import mapImg from "../../../../assets/images/map.png"
import "./SearchResidencePage.css"

const SearchResidencePage = () => {
  const contextRef = useRef(null)
  const data = [
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "false",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "new",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "immidiate",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "new",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "false",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "false",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
  ]





  return <div className=" ">
    <Container fluid className="p-1  m-3-b">
      <Ref innerRef={contextRef}>

        <InfiniteScroll
          pageStart={0}
          // loadMore={loadFunc}
          hasMore={true}
          loader={<Grid  className="p-1 m-0" columns={1}>{
            [0, 1].map((item, index) => {
              return <><Grid.Column width={10}>
                <Placeholder fluid>
                  <Placeholder.Header style={{ height: 250 }}>
                    <Placeholder.Image />
                  </Placeholder.Header>

                </Placeholder>
              </Grid.Column>
              <Grid.Column width={6}></Grid.Column></>
            })
          }</Grid>}
        >
          <Grid stackable columns={2} className="rounded-15 m-1">
            <Grid.Column width={10}>
              <SearchResidenceCard data={data} />
            </Grid.Column>
            <Grid.Column width={6}>
              <Sticky context={contextRef}>
                <Image src={mapImg} />
              </Sticky>
            </Grid.Column>
          </Grid>
        </InfiniteScroll>
      </Ref>

    </Container>
  </div>
}
export default SearchResidencePage